import { useAppSettings } from "@/context/AppSettingsContext";

interface BrandLogoProps {
  size?: number;
  className?: string;
  rounded?: boolean;
}

export default function BrandLogo({ size = 48, className = "", rounded = false }: BrandLogoProps) {
  const { logoUrl, settings } = useAppSettings();
  const alt = settings.company_name || "Sistema RKC";

  return (
    <div
      className={`flex shrink-0 items-center justify-center ${className}`}
      style={{ width: size, height: size }}
    >
      <img
        src={logoUrl}
        alt={alt}
        title={`${alt} - Neumáticos & Servicios`}
        className={`h-full w-full object-contain ${rounded ? "rounded-full" : ""}`}
      />
    </div>
  );
}